import React, { Component } from "react";
import PropTypes from "prop-types";

const isValidSessionKey = () => {
  const k = localStorage.getItem("sessionKey");
  return !!k && k !== "undefined" && k !== "null";
};

export default function(ComposedComponent) {
  class Authentication extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    componentWillUpdate() {
      if (!isValidSessionKey()) {
        localStorage.clear();
        this.props.history.push("/");
      }
    }

    componentWillMount() {
      if (!isValidSessionKey()) {
        localStorage.clear();
        this.props.history.push("/");
      }
    }

    render() {
      if (!isValidSessionKey()) {
        return null;
      }
      return <ComposedComponent {...this.props} />;
    }
  }

  return Authentication;
}



// WEBPACK FOOTER //
// ./src/components/requireAuth.js